import {type Dictionary} from '@malt/types-utils';

export function getHttpHeaders(): Dictionary {
    const headers: Dictionary<any> = {};

    if ((typeof process === 'undefined' || (typeof process !== 'undefined' && (process as any)?.client)) && typeof window !== 'undefined') {
        const queryParams = parseUrlParams(window.location.search);

        if (queryParams.has('immersion')) {
            headers['X-Immersion-Identity'] = queryParams.get('immersion');
        }
        if (queryParams.has('identityId')) {
            headers['X-Immersion-Identity'] = queryParams.get('identityId');
        }
        if (!headers['X-Immersion-Identity'] && document && document.getElementsByClassName('immersion-frame').length > 0) {
            headers['X-Immersion-Identity'] = 'default';
        }
    }

    return headers;
}

function parseUrlParams(params: string): URLSearchParams {
    return new URLSearchParams(params ? params.substring(1) : '');
}
